import { date, object, string } from 'yup';

import { ContractBillingStatusPascalCaseEnum } from '@/graphql/contracts/_generated_/contracts';

export const pauseContractLineGridValidationSchema = object().shape({
  lineBillingStatusUpdateReasonCode: string()
    .nullable()
    .when('lineBillingStatus', {
      is: ContractBillingStatusPascalCaseEnum.On,
      then: (schema) => schema.required('Reason Code is required'),
      otherwise: (schema) => schema.nullable(),
    }),

  lineBillingCurrentStatusStartDate: date()
    .nullable()
    .test('is-not-in-past', 'Start date cannot be in the past', function (value) {
      if (!value || !this.parent.startDateHasChanged) {
        return true;
      }
      const result = new Date(value) >= new Date(new Date().setHours(0, 0, 0, 0));
      console.log('start date gridValidation result', { value, result });
      return result;
    }),

  lineBillingCurrentStatusEndDate: date()
    .min(new Date(new Date().setHours(0, 0, 0, 0)), 'Date cannot be in the past')
    .test('is-after-start', 'End date must be after start date', function (value) {
      const startDate = this.parent.lineBillingCurrentStatusStartDate;
      if (!value || !startDate) {
        return true;
      }

      return new Date(value) > new Date(startDate);
    })
    .nullable()
    .required('You must enter an end date'),

  lineBillingStatusUpdateComment: string()
    .max(100, 'Must be maximum 100 characters')
    .nullable(),

  lineBillingStatusUpdateReference: string()
    .max(50, 'Must be maximum 50 characters')
    .nullable(),
});
